import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import CaseStudies from './pages/CaseStudies';
import Blog from './pages/Blog';
import Contact from './pages/Contact';

// Admin components
import AdminLogin from './admin/components/AdminLogin';
import AdminLayout from './admin/components/AdminLayout';
import ProtectedRoute from './admin/components/ProtectedRoute';
import Dashboard from './admin/pages/Dashboard';
import UserManagement from './admin/pages/UserManagement';
import PageManagement from './admin/pages/PageManagement';
import ContactManagement from './admin/pages/ContactManagement';
import Settings from './admin/pages/Settings';
import ServicesManagement from './admin/pages/ServicesManagement';
import ValuesManagement from './admin/pages/ValuesManagement';
import TeamManagement from './admin/pages/TeamManagement';
import JourneyManagement from './admin/pages/JourneyManagement';
import CaseStudiesManagement from './admin/pages/CaseStudiesManagement';
import BlogManagement from './admin/pages/BlogManagement';

import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Admin Routes - Separate from public routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              <AdminLayout>
                <UserManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/pages" element={
            <ProtectedRoute>
              <AdminLayout>
                <PageManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/contact" element={
            <ProtectedRoute>
              <AdminLayout>
                <ContactManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute>
              <AdminLayout>
                <Settings />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/services" element={
            <ProtectedRoute>
              <AdminLayout>
                <ServicesManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/values" element={
            <ProtectedRoute>
              <AdminLayout>
                <ValuesManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/team" element={
            <ProtectedRoute>
              <AdminLayout>
                <TeamManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/journey" element={
            <ProtectedRoute>
              <AdminLayout>
                <JourneyManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/case-studies" element={
            <ProtectedRoute>
              <AdminLayout>
                <CaseStudiesManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/blog" element={
            <ProtectedRoute>
              <AdminLayout>
                <BlogManagement />
              </AdminLayout>
            </ProtectedRoute>
          } />

          {/* Public Routes */}
          <Route path="/" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Home />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/services" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Services />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/about" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <About />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/case-studies" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <CaseStudies />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/blog" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Blog />
              </main>
              <Footer />
            </div>
          } />
          <Route path="/contact" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Contact />
              </main>
              <Footer />
            </div>
          } />

          {/* Catch-all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;